export default __webpack_public_path__ + "static/media/fixColumnLeft.2c7b041c.svg";